/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

const stroke = 'geometry.stroke';
const fill = 'geometry.fill';
const transitLine = 'transit.line';
export const saturatedMapStyle: google.maps.MapTypeStyle[] = [
  {
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ddece7'
      }
    ]
  },
  {
    featureType: 'administrative',
    elementType: stroke,
    stylers: [
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: 'landscape.man_made',
    elementType: fill,
    stylers: [
      {
        color: '#f2f2f2'
      }
    ]
  },
  {
    featureType: 'landscape.natural',
    elementType: fill,
    stylers: [
      {
        color: '#e6eeee'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: fill,
    stylers: [
      {
        color: '#dce0dc'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: stroke,
    stylers: [
      {
        color: '#f5f5f5'
      },
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: 'poi.business',
    elementType: fill,
    stylers: [
      {
        color: '#e1e1e1'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: fill,
    stylers: [
      {
        color: '#ddece7'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text',
    stylers: [
      {
        color: '#bcbcbc'
      },
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: fill
  },
  {
    featureType: 'road.arterial',
    elementType: fill
  },
  {
    featureType: 'road.arterial',
    elementType: stroke,
    stylers: [
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: fill,
    stylers: [
      {
        color: '#aaa9aa'
      },
      {
        lightness: 60
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: stroke,
    stylers: [
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: fill,
    stylers: [
      {
        color: '#aaa9aa'
      },
      {
        lightness: 30
      }
    ]
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: stroke,
    stylers: [
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: 'road.local',
    elementType: fill
  },
  {
    featureType: 'road.local',
    elementType: stroke,
    stylers: [
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: transitLine,
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: transitLine,
    elementType: fill,
    stylers: [
      {
        color: '#a8a8a8'
      }
    ]
  },
  {
    featureType: transitLine,
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#bcbcbc'
      },
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: transitLine,
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#949494'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: fill,
    stylers: [
      {
        color: '#afc4c9'
      }
    ]
  }
];
